module.exports = __webpack_public_path__ + "img/freccia_giù.0803630d.svg";